import { faCircleCheck as fasCircleCheck } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { AbstractStep, type AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { renderText } from "../domain";

interface Props extends AbstractStepProps {
	eligibleForWorkerLoan: boolean;
}

export class SuccessPage extends AbstractStep<{}, Props> {
	protected renderContent(): ReactNode {
		const { eligibleForWorkerLoan } = this.props;
		const { alternativeSolution, compareOffers } = renderText(eligibleForWorkerLoan);

		return (
			<>
				<Card.Header className="bg-success-700 text-white">
					<div className="d-flex px-3 py-2 border-bottom">
						<div className="text-center my-auto ml-auto">
							<FontAwesomeIcon icon={fasCircleCheck} className="text-gold" size="4x" />
						</div>
						<div className="h4 mb-0 font-weight-bold text-center">
							Elküldtük neked a kölcsön részletes leírását
						</div>
					</div>
					<div className="small text-center pt-3">
						Ha addig is további kérdésed lenne, írj nekünk a{" "}
						<a className="text-reset text-underline" href="mailto:bankmonitor@bankonitor.hu">
							bankmonitor@bankonitor.hu
						</a>{" "}
						címre.
					</div>
				</Card.Header>
				<Card.Body className="bg-success-500 text-white text-center">
					<h3 className="mt-3">{alternativeSolution}</h3>
					<h4 className="mt-5">{compareOffers}</h4>
				</Card.Body>
				<Card.Footer className="bg-success">
					<Button
						href="/szemelyi-kolcson?link_type=in-calculator"
						className="font-weight-bold"
						variant="gold"
						block
						onClick={() => this.sendEvent("BM_openCalculator")}
					>
						Ugrás a kalkulátorra
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "SuccessPage";
	}
}
